IREP.DivScroller = (function () {

    var defaultOptions = {
        windowPane: "dvScroller",
        innerPane: "dvScrollerInside",
        divHolder: "dvCommentHolder",
        prevBtn: "prevSet",
        nextBtn: "nextSet",
        indexDisplay: "dvNotif",
        displayCount: 5,
        textTemplate: "Showing {0}-{1} of {2} items"
    };

    var init = function (options) {
        var currentItem = 1;

        // To avoid scope issues, use 'base' instead of 'this'
        // to reference this class from internal events and functions.
        var base = this;

        if (options !== null)
            base.options = options;
        else
            base.options = defaultOptions;

        base.init = function () {
            //Set the size of the container div to the size of five divs. 
            var numPanels = base.options.displayCount;
            if ($("." + base.options.divHolder + ":visible").length < numPanels) {
                numPanels = $("." + base.options.divHolder + ":visible").length;
            }
            $("#" + base.options.windowPane).height($("." + base.options.divHolder).outerHeight(true) * numPanels);

            $("#" + base.options.prevBtn).on("click", function () { base.RollTab(base.options.displayCount, 0); return false; });
            $("#" + base.options.nextBtn).on("click", function () { base.RollTab(base.options.displayCount, 1); return false; });
            base.manageButtonVisibility();
        };

        //Outer Height grabs the size of the item that we're scrolling by, giving us a constant scroll on our inside scroller. 
        base.RollTab = function (displayCount, scrollUp) {
            //Animate the scroll
            for (var i = 0; i < displayCount; i++) {
                if (scrollUp === 1) {
                    $("#" + base.options.innerPane).animate({ top: '-=' + $("." + base.options.divHolder).outerHeight(true) }, 75, function () { base.manageButtonVisibility(); });
                } else {
                    $("#" + base.options.innerPane).animate({ top: '+=' + $("." + base.options.divHolder).outerHeight(true) }, 75, function () { base.manageButtonVisibility(); });
                }
            }

            //Keep track of which record we're showing, for our counter text. 
            if (scrollUp === 1) {
                currentItem = currentItem + displayCount;
            } else {
                currentItem = currentItem - displayCount;
            }
        };

        //Change the text on the 'showing' bar, and handle button disability. 
        base.manageButtonVisibility = function () {
            var startPoint = currentItem;
            var endPoint = startPoint + (base.options.displayCount - 1);
            var maxRecords = $("." + base.options.divHolder + ":visible").length;
            if (endPoint > maxRecords) endPoint = maxRecords;

            if (startPoint <= 1)
                $("#" + base.options.prevBtn).hide();
            else
                $("#" + base.options.prevBtn).show();

            if (endPoint >= maxRecords)
                $("#" + base.options.nextBtn).hide();
            else
                $("#" + base.options.nextBtn).show();

            var labelStr = base.options.textTemplate;
            labelStr = labelStr.replace("{0}", startPoint.toString())
                               .replace("{1}", endPoint.toString())
                               .replace("{2}", maxRecords.toString());
            $("#" + base.options.indexDisplay).html(labelStr);
        };

        // Run initializer
        base.init();
    };

    $.fn.divScroller = function (options) {
        return this.each(function () {
            (new $.divScroller(this, options));
        });
    };
    
    return {
        init: init
    };

})();

